export const getPageCount = (pageSize?: number, totalCount?: number): number => {
    const pageSizeValue =  pageSize ?? 1;
    const totalCountValue =  totalCount ?? 1;

     return Math.ceil(totalCountValue / pageSizeValue);
};